module.exports = __webpack_public_path__ + "img/module.24773a5.png";